// extracted by mini-css-extract-plugin
export default {"iconColorSecondary":"useIconColor_iconColorSecondary__kL3i2"};